import React, { Component } from "react";
import { GetData } from "../../api/service";
import { Typography } from "@material-ui/core";

import { Menu } from "antd";
import { MenuUnfoldOutlined } from "@ant-design/icons";
const { SubMenu } = Menu;

const data = [
  {
    title: "HOME",
    path: "/",
    hasSubnav: false,
    subnav: [],
  },
  {
    title: "ABOUT US",
    path: "/aboutus/about",
    hasSubnav: true,
    subnav: [
      {
        title: "About",
        path: "/aboutus/about",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Vision",
        path: "/aboutus/vision",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Mission",
        path: "/aboutus/mission",
        hasSubnav: false,
        subnav: [],
      },

      {
        title: "Core Values",
        path: "/aboutus/corevalues",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "College At a Glance",
        path: "/aboutus/history",
        hasSubnav: false,
        subnav: [],
      },

      {
        title: "Glorious Past",
        path: "/aboutus/past",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Recognitions",
        path: "/aboutus/icv",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Certifications",
        path: "/aboutus/certifications",
        hasSubnav: false,
        subnav: [],
      },
    ],
  },
  // {
  //   title: 'NOTICES',
  //   path: '/notifications/administrative',
  //   hasSubnav: false,
  //   subnav: []
  // },
  // {
  //   title: 'EVENTS',
  //   path: '/events',
  //   hasSubnav: false,
  //   subnav: []
  // },
  // {
  //   title: 'ACADEMIC',
  //   path: '/',
  //   hasSubnav: true,
  //   subnav: [
  //     {
  //       title: 'Programmes & Courses',
  //       path: '/departments',
  //       hasSubnav: false,
  //       subnav: []
  //     },
  //     {
  //       title: 'Admission Procedure',
  //       path: '/departments',
  //       hasSubnav: false,
  //       subnav: []
  //     },
  //     {
  //       title: 'Examination',
  //       path: '/departments',
  //       hasSubnav: false,
  //       subnav: []
  //     },
  //     {
  //       title: 'Rules & Regulations',
  //       path: '/departments',
  //       hasSubnav: false,
  //       subnav: []
  //     },
  //   ]
  // },
  {
    title: "DEPARTMENTS",
    path: "/departments",
    hasSubnav: true,
    subnav: [],
  },
  {
    title: "ADMINISTRATIONS",
    path: "/administrations/principal",
    hasSubnav: true,
    subnav: [
      {
        title: "From the desk of Principal",
        path: "/administrations/principal",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Governing Body",
        path: "/administrations/gb",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Office Staff",
        path: "/administrations/officestaff",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Code of Conduct",
        path: "/administrations/codeofconduct",
        hasSubnav: false,
        subnav: [],
      },
    ],
  },

  {
    title: "STUDENTS CORNER",
    path: "/students/notification",
    hasSubnav: true,
    subnav: [
      {
        title: "Apply for Certificates",
        path: "/students/certificates",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Notification",
        path: "/students/notification",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Downloads",
        path: "/students/downloads",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Class Routines",
        path: "/students/routines",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Exam Results",
        path: "/students/results",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Exam Schedules",
        path: "/students/exam-schedule",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Student Clubs",
        path: "/students/clubs",
        hasSubnav: false,
        subnav: [],
      },
      // {
      //   title: `Student's Union`, // new
      //   path: '/students/clubs',
      //   hasSubnav: false,
      //   subnav: []
      // },
      {
        title: `Alumni`, // new
        path: "/students/clubs",
        hasSubnav: true,
        subnav: [
          // {
          //   title: `Alumni Association`, // new
          //   path: '/students/clubs',
          //   hasSubnav: false,
          //   subnav: []
          // },

          {
            title: `Prominent Alumni`, // new
            path: "/alumni/prominent",
            hasSubnav: false,
            subnav: [],
          },
          {
            title: `Alumni List`, // new
            path: "/alumni/list",
            hasSubnav: false,
            subnav: [],
          },
        ],
      },
      // {
      //   title: `College Magazine`, // new
      //   path: '/students/clubs',
      //   hasSubnav: false,
      //   subnav: []
      // },
    ],
  },

  {
    title: "FACILITIES",
    path: "/facility/library",
    hasSubnav: true,
    subnav: [
      {
        title: "Canteen",
        path: "/facility/canteen",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Auditorium",
        path: "/facility/auditorium",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Conference Hall",
        path: "/facility/conferencehall",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Gynmasium",
        path: "/facility/gymnasium",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "NCC",
        path: "##3",
        isLink: true,
        link: "https://ncc.dispurcollege.ac.in/",
        hasSubnav: false,
        subnav: [],
      },
      // {
      //   title: 'NSS',
      //   path: '/facility/nss',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Daycare Room',
      //   path: '/facility/daycare-room',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Digital Class Room',
      //   path: '/facility/digital-classroom',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Computer Lab',
      //   path: '/facility/computer-lab',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Language Lab',
      //   path: '/facility/language-lab',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Yoga & Meditation',
      //   path: '/facility/yoga-meditation',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Taekwndo',
      //   path: '/facility/taekwndo',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Soft Skill Training',
      //   path: '/facility/soft-skill',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Psycological Counselling',
      //   path: '/facility/psycological-counselling',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Facilities for Dibyangan Students',
      //   path: '/facility/da-students',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Washroom for Transgender',
      //   path: '/facility/transgender',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'RO Drinking Water',
      //   path: '/facility/ro-driniking-water',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Common room for Boy & Girls',
      //   path: '/facility/common-room-boys-girls',
      //   hasSubnav: false,
      //   subnav: []
      // },
      // {
      //   title: 'Contineuous Enhancement of Skill',
      //   path: '/facility/enhancement-of-skills',
      //   hasSubnav: false,
      //   subnav: []
      // },
    ],
  },
  {
    title: "LIBRARY",
    path: "##67",
    isLink: true,
    link: "https://library.dispurcollege.ac.in/",
    hasSubnav: false,
    subnav: [],
  },
  {
    title: "ACHIEVEMENTS",
    path: "/notifications/achievements",
    hasSubnav: false,
    subnav: [],
  },
  {
    title: "E-CONTENTS",
    path: "/e-content/class_note",
    hasSubnav: false,
    subnav: [],
  },
  {
    title: "PUBLICATIONS",
    path: "/publication/college",
    hasSubnav: true,
    subnav: [
      {
      title: "College Publications",
      path: "/publication/college",
      hasSubnav: false,
      subnav: [],
    },
    {
      title: "Departmental Wall-Magazines",
      path: "/publication/department",
      hasSubnav: false,
      subnav: [],
    },
  ],
  },

  {
    title: "IQAC",
    path: "/iqac/about",
    hasSubnav: true,
    subnav: [
      {
        title: "About",
        path: "/iqac/about",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Committee",
        path: "/iqac/teams",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "SSR",
        path: "/iqac/ssr",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "AQAR",
        path: "/iqac/aqar",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Action Taken Report",
        path: "/iqac/atr",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Meeting Minutes",
        path: "/iqac/minutes",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Feedbacks",
        path: "/iqac/feedbacks",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Convenor / Coordinators",
        path: "/iqac/previosconvenor",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Assistant Coordinator",
        path: "/iqac/assistantcoordinator",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "SOPs & Policies",
        path: "/iqac/sops",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "MoUs & Collaborations",
        path: "/iqac/collaborations",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Notifications",
        path: "/iqac/notices",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Declarations",
        path: "/iqac/declaration",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Institutional Perspective Plan",
        path: "/iqac/institutional-perspective-plan",
        hasSubnav: false,
        subnav: [],
      },

      {
        title: "Best Practices",
        path: "/iqac/best-practices",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Institutional Distinctiveness",
        path: "/iqac/institutional-distinctiveness",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Course Outcome & Program Outcome",
        path: "/iqac/iqac-co",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Seminars/Webinars/Conferences",
        path: "/iqac/iqac-seminars",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Organogram",
        path: "/iqac/iqac-organogram",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Research Papers/Books/Edited Books/Book Chapters",
        path: "/iqac/research-papers",
        hasSubnav: false,
        subnav: [],
      },
      // {
      //   title: 'PUBLICATIONS', // to be done
      //   path: '/notifications/publications',
      //   hasSubnav: true,
      //   subnav: [
      //     {
      //       title: 'Book Publications', // to be done
      //       path: '/notifications/book',
      //       hasSubnav: false,
      //       subnav: []
      //     },
      //     {
      //       title: 'Newpaper Publications', // to be done
      //       path: '/notifications/newspaper',
      //       hasSubnav: false,
      //       subnav: []
      //     },
      //   ]
      // },
      // {
      //   title: 'AISHE Data',
      //   path: '/iqac/aishe',
      //   hasSubnav: false,
      //   subnav: []
      // },
    ],
  },
  {
    title: "IIC",
    path: "/iic/activity",
    hasSubnav: true,
    subnav: [
      {
        title: "Events/Activity",
        path: "/iic/activity",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Gallery",
        path: "/iic/gallery",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Certificates",
        path: "/iic/certificate",
        hasSubnav: false,
        subnav: [],
      },
    ],
  },
  {
    title: "UBA",
    path: "/uba/activity",
    hasSubnav: true,
    subnav: [
      {
        title: "Activity",
        path: "/uba/activity",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Gallery",
        path: "/uba/gallery",
        hasSubnav: false,
        subnav: [],
      },
    ],
  },
  {
    title: "AISHE",
    path: "/iqac/aishe",
    hasSubnav: false,
    subnav: [],
  },
  {
    title: "NIRF",
    path: "/nirf",
    hasSubnav: false,
    subnav: [],
  },
  {
    title: "ANTI-RAGGING",
    path: "/anti-ragging",
    hasSubnav: false,
    subnav: [],
  },

  // {
  //   title: 'RTI',
  //   path: '/rti/home',
  //   hasSubnav: false,
  //   subnav: []
  // },
  // {
  //   title: 'ALUMNI',
  //   path: '/alumni/committee',
  //   hasSubnav: false,
  //   subnav: []
  // },

  {
    title: "NOTICES",
    path: "/notifications/administrative",
    hasSubnav: true,
    subnav: [
      {
        title: "Administrative Notices",
        path: "/notifications/administrative",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Academic Notices",
        path: "/notifications/academic",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: "Events",
        path: "/notifications/events",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: `Principal's Monthly Report`,
        path: "/notifications/principal_activity",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: `Recent Achievements`,
        path: "/notifications/achievements",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: `Student Achievements`,
        path: "/notifications/sachievements",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: `Employee Achievements`,
        path: "/notifications/eachievements",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: `Downloads`,
        path: "/notifications/downloads",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: `Activity`,
        path: "/notifications/activity",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: `Tender`,
        path: "/notifications/tender",
        hasSubnav: false,
        subnav: [],
      },
      {
        title: `Contact Us`,
        path: "/contactus",
        hasSubnav: false,
        subnav: [],
      },
    ],
  },
  {
    title: "ITEP",
    path: "/itep/notifications",
    hasSubnav: false,
    subnav: [],
  },
  {
    title: "CONTACT US",
    path: "/contactus",
    hasSubnav: false,
    subnav: [],
  },
];

const pos = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  zIndex: 1000,
  justifyContent: "end",
};

class MultiNavBar extends Component {
  state = {
    departments: [],
    isLoaded: false,
    data: data,
    current: "/",
    facilities: [],
  };
  createBlogLink = (title) => {
    // Convert the title to lowercase
    let lowerCaseTitle = title.toLowerCase();

    // Replace spaces and special characters with hyphens
    let urlFriendlyTitle = lowerCaseTitle.replace(/[^a-z0-9]+/g, "-");

    // Remove leading or trailing hyphens
    urlFriendlyTitle = urlFriendlyTitle.replace(/^-+|-+$/g, "");

    return urlFriendlyTitle;
  };
  componentDidMount() {
    GetData(`/getdepartments`).then((resp) => {
      console.log(
        "🚀 ~ file: SubNav3.js:398 ~ MultiNavBar ~ .then ~ resp",
        resp
      );
      //console.log(resp)

      // arrange them

      let arts = resp.filter((el) => el.stream == "ARTS");
      let science = resp.filter((el) => el.stream == "COMMERCE");
      let others = resp.filter((el) => el.stream == "OTHERS");

      let arts_arr = [];
      arts.map((el, index) =>
        arts_arr.push({
          title: el.dept_name,
          path: `/department/${el.dept_code}`,
          hasSubnav: false,
          subnav: [],
        })
      );

      let science_arr = [];
      science.map((el, index) =>
        science_arr.push({
          title: el.dept_name,
          path: `/department/${el.dept_code}`,
          hasSubnav: false,
          subnav: [],
        })
      );

      let other_arr = [];
      others.map((el, index) =>
        other_arr.push({
          title: el.dept_name,
          path: `/department/${el.dept_code}`,
          hasSubnav: false,
          subnav: [],
        })
      );

      let all_d = {
        title: "All",
        path: "/departments",
        hasSubnav: false,
        subnav: [],
      };

      let arts_d = {
        title: "Arts",
        path: "",
        hasSubnav: true,
        subnav: arts_arr,
      };

      let science_d = {
        title: "Commerce",
        path: "",
        hasSubnav: true,
        subnav: science_arr,
      };

      let others_d = {
        title: "Professional",
        path: "",
        hasSubnav: true,
        subnav: other_arr,
      };

      let d = [all_d, arts_d, science_d, others_d];

      let data = this.state.data;
      data[2].subnav = d;

      // for people

      let teaching_people = resp.map((el, index) => {
        return {
          title: el.dept_name,
          path: `/department/${el.dept_code}/faculty`,
          hasSubnav: false,
          subnav: [],
        };
      });

      //data[5]['subnav'][1]['subnav'] = teaching_people

      //console.log(data)
      this.setState(
        {
          data: data,
          isLoaded: true,
          current: this.props.history.location.pathname,
        },
        () => {
          // console.log(this.state)
        }
      );
    });

    // Update the facilities
    GetData(`/getcollegefacilitylist`).then((resp) => {
      let fac = [
        {
          title: "NCC",
          path: "##678",
          isLink: true,
          link: "https://ncc.dispurcollege.ac.in/",
          hasSubnav: false,
          subnav: [],
        },
        {
          title: "NSS",
          path: "/nss/home",
          hasSubnav: false,
          subnav: [],
        },
      ];

      fac = [
        ...fac,
        ...resp.map((el) => ({
          title: el.title,
          path: `/facility/${this.createBlogLink(el.title)}-${el.id}`,
          hasSubnav: false,
          subnav: [],
        })),
      ];

      let data = this.state.data;
      data[5].subnav = fac;
    });
  }

  handleClick = (e) => {
    this.props.history.push(e.key);
    this.setState({
      current: e.key,
    });
  };

  render() {
    return (
      <div
        style={
          this.props.sticky
            ? {
                ...pos,
              }
            : null
        }
        className={`navStyle-new`}
      >
        <Menu
          size="small"
          onClick={this.handleClick}
          style={{
            background: "#2D3192",
            border: "none",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            
          }}
          selectedKeys={[this.state.current]}
          overflowedIndicator={<MenuUnfoldOutlined />}
          mode="horizontal"
        >
          {this.state.data.map((el, index) => {
            if (el.hasSubnav) {
              return (
                <SubMenu title={el.title} className="navItemPandu">
                  {el.subnav.map((el1, index1) => {
                    if (el1.hasSubnav) {
                      return (
                        <SubMenu title={el1.title}>
                          {el1.subnav.map((el2, index2) => {
                            if (el2.isLink == true) {
                              return (
                                <Menu.Item key={`no`}>
                                  <a target="_blank" href={el2.link}>
                                    {el2.title}
                                  </a>
                                </Menu.Item>
                              );
                            } else {
                              return (
                                <Menu.Item key={el2.path}>
                                  {el2.title}
                                </Menu.Item>
                              );
                            }
                          })}
                        </SubMenu>
                      );
                    } else {
                      if (el1.isLink == true) {
                        return (
                          <Menu.Item key={`no`}>
                            <a target="_blank" href={el1.link}>
                              {el1.title}
                            </a>
                          </Menu.Item>
                        );
                      } else {
                        return (
                          <Menu.Item key={el1.path} >{el1.title}</Menu.Item>
                        );
                      }
                    }
                  })}
                </SubMenu>
              );
            } else {
              //else inacticvated
              if (el.isLink == true) {
                return (
                  <Menu.Item key="no" className="navItemPandu">
                    <a
                      target="_blank"
                      href={el.link}
                      style={{ color: "white" }}
                    >
                      {el.title}
                    </a>
                  </Menu.Item>
                );
              } else {
                return (
                  <Menu.Item key="mail" key={el.path} className="navItemPandu">
                    {el.title}
                  </Menu.Item>
                );
              }
            }
          })}
        </Menu>

        {/* <div
          style={{
            display: 'flex',
            backgroundColor: this.props.backgroundOfNav,
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '1px 2px 3px rgba(0,0,0,0.4)',
            width: '100%',
            //overflowY: 'auto'
          }}
        >
          {this.state.data.map((el, index) =>
            <OneNavBar
              key={index}
              {...el}
              width={this.props.width}
              color={this.props.color}
              backgroundOfNav={this.props.backgroundOfNav}
              backgroundColor={this.props.backgroundColor}
              textColor={this.props.textColor}
              history={this.props.history}
            />
          )}
        </div> */}
      </div>
    );
  }
}

export default MultiNavBar;

class OneNavBar extends Component {
  state = {
    hover: false,
  };

  onMouseEnter = () => {
    this.setState({
      hover: true,
    });
  };

  onMouseLeave = () => {
    this.setState({
      hover: false,
    });
  };

  render() {
    return (
      <div
        style={{
          padding: "10px 10px 10px 10px",
          cursor: "pointer",
          position: "relative",
          color: this.props.color,
        }}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onMouseOver={this.onMouseEnter}
        onClick={() =>
          !this.props.hasSubnav
            ? this.props.history.push(this.props.path)
            : null
        }
      >
        <Typography variant="subtitle2">{this.props.title}</Typography>

        {this.props.hasSubnav && this.state.hover ? (
          <div
            style={{
              backgroundColor: this.props.backgroundColor,
              position: "absolute",
              minWidth: this.props.width,
              zIndex: 999,
              display: "grid",
              gridTemplateRows: "1fr",
              boxShadow: "1px 1px 3px rgba(0,0,0,0.3)",
            }}
          >
            {this.props.subnav.map((el, index) => (
              <OneSideNav
                key={index}
                {...el}
                width={this.props.width}
                color={this.props.color}
                backgroundOfNav={this.props.backgroundOfNav}
                backgroundColor={this.props.backgroundColor}
                textColor={this.props.textColor}
                history={this.props.history}
              />
            ))}
          </div>
        ) : null}
      </div>
    );
  }
}

class OneSideNav extends Component {
  state = {
    hover: false,
  };
  onMouseEnter = () => {
    this.setState({
      hover: true,
    });
  };

  onMouseLeave = () => {
    this.setState({
      hover: false,
    });
  };
  render() {
    return (
      <div
        style={{
          color: this.props.textColor,
          backgroundColor: this.props.backgroundColor,
          position: "relative",
          minWidth: this.props.width,
          padding: "10px",
          borderBottom: "solid thin lightgrey",
          borderRight: "solid thin lightgrey",
          boxShadow: "1px 2px 3px rgba(0,0,0,0.3)",
        }}
        onClick={() =>
          !this.props.hasSubnav
            ? this.props.history.push(this.props.path)
            : null
        }
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onMouseOver={this.onMouseEnter}
      >
        <font style={{ fontSize: "0.8em" }}>{this.props.title}</font>{" "}
        {this.props.hasSubnav ? (
          <span
            className="fa fa-angle-right"
            style={{
              fontSize: "0.6em",
              float: "right",
              marginTop: "8px",
            }}
          ></span>
        ) : null}
        {this.props.hasSubnav && this.state.hover ? (
          <div
            style={{
              position: "absolute",
              zIndex: 999,
              left: 0,
              marginLeft: this.props.width,
              top: 0,
              backgroundColor: this.props.backgroundColor,
            }}
          >
            {this.props.subnav.map((el, index) => (
              <OneSideNav
                key={index}
                {...el}
                width={this.props.width}
                color={this.props.color}
                backgroundOfNav={this.props.backgroundOfNav}
                backgroundColor={this.props.backgroundColor}
                history={this.props.history}
              />
            ))}
          </div>
        ) : null}
      </div>
    );
  }
}
